<template>
    <div class="loading light" :class="{show:showLoadingLightThisId || show}">
        <div class="overlay" v-if="overlay">

        </div>
        <div class="animation-container">
            <div class="loader-2" :style="{borderColor:color}"><span class="loader-inner" :style="{backgroundColor:color}"></span></div>
        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'
    import {mapGetters} from 'vuex';

    import LoadingIcon from '@a/img/loading.svg'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            LoadingIcon
        },
        computed: {
            ...mapGetters({
                showLoadingLight: 'UI/showLoadingLight'
            }),
            showLoadingLightThisId(){
                return this.showLoadingLight[this.id]
            }
        },
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {},
        mounted: function () {
            if(this.show === true){

            }
        },
        name: 'LoadingLight',
        props: {
            id: {
                type: String,
                required: true
            },
            show: {
                type: Boolean,
                default: false
            },
            overlay: {
                type: Boolean,
                default: true
            },
            color: {
                type: String,
                default: ''
            }
        },
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
    .loading{
        &.light{
            .overlay{
                background-color: rgba($main-white,1);
            }
            .animation-container{
                color: $main-color;

                .loader-2 {
                    border: 3px solid $main-color;
                    padding: 2px;
                }
                .loader-inner {
                    background-color: $main-color;
                    border: 0px solid transparent;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ui/LoadingLight.vue